// extracted by mini-css-extract-plugin
module.exports = {"all-btn":"AllBtn_all-btn__2zMJY","all-btn-icon":"AllBtn_all-btn-icon__3eIBu","normal":"AllBtn_normal__1x9Xn","hover":"AllBtn_hover__3MCUA"};